import { render, staticRenderFns } from "./NalandaEventCreate.vue?vue&type=template&id=549c0d9d"
import script from "./NalandaEventCreate.vue?vue&type=script&lang=js"
export * from "./NalandaEventCreate.vue?vue&type=script&lang=js"
import style0 from "./NalandaEventCreate.vue?vue&type=style&index=0&id=549c0d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports